import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { authGoogleSession } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Waves, Loader2 } from "lucide-react";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = location.hash || window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;
    // Clear the fragment from the URL immediately.
    window.history.replaceState(null, "", window.location.pathname + window.location.search);

    if (!sessionId) {
      navigate("/login");
      return;
    }
    (async () => {
      try {
        const user = await authGoogleSession(sessionId);
        setUser(user);
        navigate("/");
      } catch (_) {
        setError("Google sign-in failed. Please try again.");
        setTimeout(() => navigate("/login"), 1800);
      }
    })();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="min-h-screen bg-zinc-950 text-zinc-100 flex items-center justify-center">
      <div className="flex flex-col items-center gap-4">
        <div className="h-12 w-12 rounded-xl bg-blue-600 flex items-center justify-center">
          <Waves className="h-7 w-7 text-white" />
        </div>
        {error ? (
          <p className="text-sm text-red-300" data-testid="callback-error">{error}</p>
        ) : (
          <p className="flex items-center gap-2 text-sm text-zinc-400" data-testid="callback-loading">
            <Loader2 className="h-4 w-4 animate-spin" /> Signing you in…
          </p>
        )}
      </div>
    </div>
  );
}
